import { createFileRoute } from "@tanstack/react-router";

import { TenantSecretListPage } from "../features/tenantSecrets/TenantSecretListPage";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets/",
)({
  component: SecretsListRoute,
});

function SecretsListRoute() {
  const { accountSlug, tenantSlug } = Route.useParams();
  return (
    <TenantSecretListPage accountSlug={accountSlug} tenantSlug={tenantSlug} />
  );
}
